import { useSelector } from "react-redux";
import { getHelpUrl, getIsInConflict, getShowLoader } from "~/Configurators/Linear/redux/selectors";
import { userIsPublic } from "~/utils/roles";
import { PageTitle } from "~/common/components/PageTitle/v2/PageTitle";
import LinearLinks, { HelpLink } from "~/Configurators/common/components/Navigation/LinearLinks";
import { KbComponent } from "~/Configurators/common/components/KbComponent";
import { LinearTeaser } from "~/Configurators/Linear/components/LinearTeaser";
import LinearSummary from "~/Configurators/common/components/Navigation/LinearSummary";
import { LinearStepNavigation } from "~/Configurators/common/components/Navigation/LinearNavigation";
import Step from "~/Configurators/Linear/components/Step";
import FullscreenLoader from "~/common/components/FullscreenLoader";
import InConflictModal from "~/Configurators/Linear/components/InConflictModal";

import { type ConfiguratorPageDefinition } from "~/Configurators/ConfiguratorPageDefinition";
import { useXmlConfiguratorTranslations } from "~/Configurators/common/useXmlConfiguratorTranslations";

export const ConfiguratorPage = ({ config }: { config: ConfiguratorPageDefinition }) => {
  const showLoader = useSelector(getShowLoader);
  const isInConflict = useSelector(getIsInConflict);
  const helpUrl = useSelector(getHelpUrl);

  const isPublicUser = userIsPublic();

  const xmlT = useXmlConfiguratorTranslations().t!;

  const title = xmlT(config.translationKeys.pageTitle);

  return (
    <div className="scha__linear-configurator">
      <PageTitle tag={"div"}>
        <div className={"scha__linear-configurator__page-title"}>
          <h1>{title}</h1>
          {helpUrl && <HelpLink url={helpUrl} />}
        </div>
      </PageTitle>
      <KbComponent />
      <div className={"scha__linear-configurator__header"}>
        <LinearLinks />
        {isPublicUser && <LinearTeaser />}
        <LinearSummary />
      </div>
      <LinearStepNavigation />
      <Step />
      {showLoader && <FullscreenLoader />}
      {isInConflict && <InConflictModal />}
    </div>
  );
};
